/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import 'react-toastify/dist/ReactToastify.css'
import notifyToast from '../../../components/Toast/Toast'
import {ToastContainer} from 'react-toastify'
import TitleComponent from '../../../components/TitleComponent/TitleComponent'
import {useParams} from 'react-router-dom'
import LoadingComponent from '../../../components/LoadingComponent/LoadingComponent'
import {fetchSifra, saveSifra, updateSifra} from '../../../api/paneliSifre'
import {PanelSifre} from '../../../models/PanelSifarniciModel'

const SifreDodaj: React.FC = () => {
    const {id} = useParams()
    const IdFromURL = Number(id)

    const [loading, setLoading] = useState(true)

    const initialValues: Partial<PanelSifre> = {
        sifra: '',
        tezina: '',
        debljina: 0,
        tipPanela: '',
        debljinaLimaGore: '',
        debljinaLimaDole: '',
        materijal: '',
    }

    const [initialData, setInitialData] = useState<Partial<PanelSifre>>(initialValues)

    useEffect(() => {
        if (IdFromURL) {
            fetchSifra(IdFromURL)
                .then((data) => {
                    setInitialData(data)
                    formik.resetForm({values: data})
                })
                .finally(() => setLoading(false))
        } else {
            setLoading(false)
        }
    }, [IdFromURL])

    const validationSchema = Yup.object({
        sifra: Yup.string()
            .min(4, 'Must be at least 4 characters')
            .required('Required'),

        tezina: Yup.number()
            .typeError('Must be a number')
            .required('Required'),

        debljina: Yup.number()
            .typeError('Must be a number')
            .required('Required'),

        tipPanela: Yup.string()
            .required('Required'),

        debljinaLimaGore: Yup.string()
            .required('Required'),

        debljinaLimaDole: Yup.string()
            .required('Required'),

        materijal: Yup.string().nullable(),
    })

    const formik = useFormik({
        initialValues: initialData,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values, {setStatus, setSubmitting}) => {
            setLoading(true)
            try {
                let response
                if (IdFromURL) {
                    response = await updateSifra(values, IdFromURL)
                } else {
                    response = await saveSifra(values)
                }

                if (response.error === 0) {
                    notifyToast(true, response.message)
                } else {
                    notifyToast(false, response.message || 'An unexpected error occurred.')
                }
            } catch (error) {
                console.error('Error: ', error)
                notifyToast(false, 'Error')
                setStatus(error)
            } finally {
                setLoading(false)
                setSubmitting(false)
            }
        },
    })

    const inputClass = (field: string) =>
        clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched[field] && formik.errors[field]},
            {'is-valid': formik.touched[field] && !formik.errors[field]}
        )

    const renderError = (field: string) =>
        formik.touched[field] && formik.errors[field] ? (
            <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>{formik.errors[field] as string}</div>
            </div>
        ) : null

    return (
        <div className='card mb-5 mb-xl-10'>
            <ToastContainer/>
            <div className='card-header border-0'>
                <div className='card-title m-0'>
                    <TitleComponent name='Šifru'/>
                </div>
            </div>

            <div className='collapse show'>
                {loading ? (
                    <LoadingComponent/>
                ) : (
                    <form onSubmit={formik.handleSubmit} noValidate className='form'>
                        <div className='card-body border-top p-9'>

                            {/* Naziv */}
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Naziv</label>
                                <div className='col-lg-8'>
                                    <input type='text' {...formik.getFieldProps('sifra')} className={inputClass('sifra')}/>
                                    {renderError('sifra')}
                                </div>
                            </div>

                            {/* Tezina */}
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Težina</label>
                                <div className='col-lg-8'>
                                    <input type='number' {...formik.getFieldProps('tezina')} className={inputClass('tezina')}/>
                                    {renderError('tezina')}
                                </div>
                            </div>

                            {/* Debljina */}
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>Debljina</label>
                                <div className='col-lg-8'>
                                    <input type='number' {...formik.getFieldProps('debljina')} className={inputClass('debljina')}/>
                                </div>
                            </div>

                            {/* Tip panela */}
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>Tip panela</label>
                                <div className='col-lg-8'>
                                    <input type='text' {...formik.getFieldProps('tipPanela')} className={inputClass('tipPanela')}/>
                                </div>
                            </div>

                            {/* Debljina lima gore */}
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>Debljina lima gore</label>
                                <div className='col-lg-8'>
                                    <input type='text' {...formik.getFieldProps('debljinaLimaGore')} className={inputClass('debljinaLimaGore')}/>
                                </div>
                            </div>

                            {/* Debljina lima dole */}
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>Debljina lima dole</label>
                                <div className='col-lg-8'>
                                    <input type='text' {...formik.getFieldProps('debljinaLimaDole')} className={inputClass('debljinaLimaDole')}/>
                                </div>
                            </div>

                            {/* Materijal */}
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>Materijal</label>
                                <div className='col-lg-8'>
                                    <input type='text' {...formik.getFieldProps('materijal')} className={inputClass('materijal')}/>
                                </div>
                            </div>

                        </div>

                        <div className='card-footer d-flex justify-content-end py-6 px-9'>
                            <button
                                type='submit'
                                className='btn btn-primary'
                                disabled={loading || formik.isSubmitting || !formik.isValid}
                            >
                                {!loading && 'Potvrdi'}
                                {loading && (
                                    <span className='indicator-progress'>
                                        Please wait...
                                        <span className='spinner-border spinner-border-sm ms-2'></span>
                                    </span>
                                )}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    )
}

export default SifreDodaj